
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames   from 'classnames/bind';
import stylingUtils from '../../services/stylingUtilities';
import ReactQuill from  '../ReactQuill';

import style from './style.scss';

class HtmlEditor extends React.Component {

    _getHtmlEditorClassName() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'editor': true,
            'editor--error': this.props.errors
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    _getContentsClass() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'quill-contents': true
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.contentsClassName));
    }

    _getQuillModules() {

        return {
            toolbar: [
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline','strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image'],
                ['clean']
            ]
        };
    }

    _getQuillFormats() {

        return [
            "header",
            "bold", "italic", "underline", "strike", "blockquote",
            "list", "bullet", "indent",
            "link", "image"
        ];
    }

    render() {

        return (
            <div className={ this._getHtmlEditorClassName() }>

                <ReactQuill theme={ this.props.theme || 'snow' }
                            onChange={ this.props.onChange }
                            modules={ this._getQuillModules() }
                            formats={ this._getQuillFormats() }
                            toolbar={ false }
                            value={ this.props.value} >

                    <div key="editor"
                         ref="editor"
                         className={ this._getContentsClass() }
                         dangerouslySetInnerHTML={{ __html: this.props.value }}>
                    </div>

                </ReactQuill>
                
            </div>
        );
    }
}

export default CSSModules(HtmlEditor, style);


// WEBPACK FOOTER //
// ./components/HtmlEditor/index.js